import { Container } from '@/atoms';
import { SliderProduct } from '@/molecules';
import { ProductBlock } from '@/organisms';
import { CardVideo } from '@/templates/card-video/CardVideo';

import { removeBaseURL } from '@/lib/utils';

const CardsVideo = ({ bloque, id, className }: any) => (
  <Container
    id={id}
    wrapper
    as="section"
    {...(bloque.backgroundColorString
      ? {
          style: { backgroundColor: bloque.backgroundColorString },
          padding: 'px-4 py-8 md:py-8',
        }
      : {})}
    {...(className && { className })}
  >
    <ProductBlock
      {...(bloque.titulo ? { title: bloque.titulo } : {})}
      {...(bloque?.link?.link
        ? {
            link: {
              href: removeBaseURL(bloque.link.link.url) || '/',
              label: bloque.link.label,
              size: bloque.link.size,
              style: bloque.link.style,
            },
          }
        : {})}
      {...(bloque.description ? { description: bloque.description } : {})}
    >
      {/** TODO: Pasar breakpoint */}
      <SliderProduct
        perPage={bloque.itemsPorPagina}
        {...(bloque.itemsPorPagina === 4
          ? {
              breakpoints: {
                1280: {
                  perPage: 4,
                },
                1024: {
                  perPage: 3,
                },
                768: {
                  perPage: 2,
                },
                640: {
                  perPage: 2,
                },
                450: {
                  perPage: 1,
                },
              },
            }
          : {})}
      >
        {bloque.cards
          ?.filter(Boolean)
          .map((card: any, key: number) => <CardVideo card={card} key={key} />)}
      </SliderProduct>
    </ProductBlock>
  </Container>
);

export default CardsVideo;

CardsVideo.displayName = 'CardsVideo';
